import {Provider} from '@angular/core';

import {BraintreeBgTranslationConfig} from '../config/braintree.bg.translation.config';

export const BRAINTREE_BG_TRANSLATION_PROVIDER: Provider[] = [
    {
        provide: BraintreeBgTranslationConfig,
        useClass: BraintreeBgTranslationConfig
    }
];
